import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { BreadcrumbComponent } from './breadcrumb.component';
import { SharedModule } from '../../shared/shared.module';

@NgModule({
  declarations: [BreadcrumbComponent],
  imports: [
      CommonModule,
      FormsModule,
      RouterModule,
      SharedModule
    ],
    exports: [BreadcrumbComponent]
})
export class BreadcrumbModule { }
